import { useMetaDataContext } from '../../state-management/contexts/MetaDataContext'
import { ReadMore } from '../ui-components/ReadMore'
import { MutualFundDetailSections, MutualFundDetailSubSections } from '../../types/mutual-fund-detail.types'
import { useMutualFundDetailScrollEvent } from '../../hooks/useMutualFundDetailScrollEvent'
import { FundManagers } from '../sub-sections/fund-manager/FundManagers'
import { AboutFund } from '../sub-sections/about-fund/AboutFund'
import { renderSubSection } from '../../utils/sectionsConfig'

export default function FundObjective({
  sectionKey,
  subsections
}: {
  sectionKey: `${MutualFundDetailSections}`
  subsections: `${MutualFundDetailSubSections}`[]
}) {
  const { data } = useMetaDataContext()

  const sectionRef = useMutualFundDetailScrollEvent({ sectionKey })

  return (
    <div ref={sectionRef} className='bg-white rounded-[12px] pb-[8px] flex flex-col w-full'>
      <div className='flex flex-col w-full gap-[8px] px-[20px] pt-[20px] pb-6'>
        <div className=' pb-[4px]'>
          <h2 className={`text-[#232323] text-[14px] font-[700] m-0`}>Fund Objective</h2>
        </div>
        <div className='text-[#6A6E6E] text-[14px] font-[400]'>
          <ReadMore
            id={'fund-objective'}
            text={data?.objective ?? ''}
            amountOfWords={25}
            labelContext='Fund Objective'
          />
        </div>{' '}
      </div>
      {subsections?.map((subsection, idx) => {
        return <div key={`${subsection}${idx}`}>{renderSubSection({ componentKey: subsection })}</div>
      })}
    </div>
  )
}
